"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = penderize;
/**
 * Appends the suffixes to the action type
 * @param {string} type 
 */
function penderize(type) {
    return {
        PENDING: type + "_PENDING",
        SUCCESS: type + "_SUCCESS",
        FAILURE: type + "_FAILURE",
        CANCEL: type + "_CANCEL"
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-pender/lib/penderize.js
// module id = 240
// module chunks = 0